import { Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import NewProductForm from 'components/addProduct/NewProductForm'
import { manufacturersQueryOptions } from 'hooks/products'

export const Route = createFileRoute('/_auth/add')({
  beforeLoad: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(manufacturersQueryOptions)
  },
  component: AddProduct,
})

function AddProduct() {
  return (
    <div>
      <Title order={1}>Dodaj nowy produkt</Title>
      <NewProductForm />
    </div>
  )
}
